export default "__VITE_ASSET__D8AYo1IY__"